import sendTestEnrichmentEmail, { SendEnrichmentEmailPayload } from './sendTestEnrichmentEmail';
import sendTestManualEmail, { SendManualEmailPayload } from './sendTestManualEmail';
import sendTestRejectionEmail, { SendRejectionEmailPayload } from './sendTestRejectionEmail';

type SendTestEmailPayload = SendRejectionEmailPayload | SendEnrichmentEmailPayload | SendManualEmailPayload;

const sendTestMail = async (name: string, payload: SendTestEmailPayload): Promise<unknown> => {
    switch (name) {
        case 'RejectionEmail':
            return await sendTestRejectionEmail(payload as SendRejectionEmailPayload);
        case 'EnrichmentEmail':
            return await sendTestEnrichmentEmail(payload as SendEnrichmentEmailPayload);
        case 'ManualEmail':
            return await sendTestManualEmail(payload as SendManualEmailPayload);
        default:
            break;
    }
}

export default sendTestMail;
